// Auto-generated by semantic-release - DO NOT EDIT
export const VERSION_INFO = {
  version: '1.82.0',
  buildDate: '2026-11-04T13:03:40.635Z',
  commitSha: '78916b0',
} as const

export type VersionInfo = typeof VERSION_INFO
